var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"party-user",attrs:{"to":'/user/'+ _vm.user.id}},[_c('div',{staticClass:"party-user__avatar",style:({ backgroundImage: 'url(' + _vm.user.avatar + ')' })}),_c('p',{staticClass:"party-user__name"},[_vm._v(_vm._s(_vm.user.firstname + ' ' + _vm.user.lastname))])])
}
var staticRenderFns = []

export { render, staticRenderFns }